import type { OffboardingQuestion, OffboardingSectionType } from "../schemas/index.ts";

function normalizeQuestionText(question: string): string {
    return question.trim().replace(/\s+/g, " ").toLowerCase();
}

function isMandatoryResignationQuestion(question: OffboardingQuestion): boolean {
    const text = normalizeQuestionText(question.question).replace(/\.$/, "");
    return (
        text === "reason for offboarding" ||
        text === "please tell us more about your offboarding request"
    );
}

function isDeprecatedOthersSpecifyQuestion(question: OffboardingQuestion): boolean {
    const text = normalizeQuestionText(question.question).replace(/\.$/, "");
    return text === "if others, please specify";
}

function isInsurancePremiumPending(
    questions: OffboardingQuestion[],
    answers: { answer?: string | string[] }[],
): boolean {
    const pendingQuestionIndex = questions.findIndex(
        (question) => question.questionId === 272,
    );
    if (pendingQuestionIndex < 0) return false;
    const answer = answers[pendingQuestionIndex]?.answer;
    return typeof answer === "string" && answer.trim().toLowerCase() === "yes";
}

export function shouldShowOffboardingQuestion(
    questions: OffboardingQuestion[],
    questionIndex: number,
    answers: { answer?: string | string[] }[],
    sectionType?: OffboardingSectionType,
): boolean {
    const question = questions[questionIndex];
    if (sectionType === "RESIGNATION" && isDeprecatedOthersSpecifyQuestion(question)) {
        return false;
    }

    if (sectionType === "PAYROLL_CLEARANCE" && question.questionId === 273) {
        return isInsurancePremiumPending(questions, answers);
    }

    return true;
}

export function isQuestionRequired(
    question: OffboardingQuestion,
    _questions: OffboardingQuestion[],
    _questionIndex: number,
    answers: { answer?: string | string[] }[],
    sectionType?: OffboardingSectionType,
): boolean {
    if (sectionType === "RESIGNATION" && isMandatoryResignationQuestion(question)) {
        return true;
    }

    if (sectionType === "PAYROLL_CLEARANCE" && question.questionId === 273) {
        return isInsurancePremiumPending(_questions, answers);
    }

    return question.mandatory;
}
